import { useState } from "react";
import { Alert, type AlertColor } from "@mui/material";
import AppSnackbar from "@/shared/ui/AppSnackbar";
import { toastAlertSx, toastFlowingBorderSx } from "@/shared/ui/systemBannerStyles";

/** How long a toast stays before it hides itself. */
const TOAST_AUTO_HIDE_MS = 5_000;

/**
 * Dismissible app toast. Centered along the bottom below `md`; bottom-left from
 * `md` up, above the table pagination bar. Open while `message` is set.
 * The last message and severity stay visible during the close transition.
 */
export default function AppToast({
  message,
  severity = "error",
  onClose,
  autoHideDuration = TOAST_AUTO_HIDE_MS,
}: Readonly<{
  message: string | null;
  severity?: AlertColor;
  onClose: () => void;
  autoHideDuration?: number;
}>) {
  const [shown, setShown] = useState({ message, severity });
  if (message != null && (message !== shown.message || severity !== shown.severity)) {
    setShown({ message, severity });
  }

  return (
    <AppSnackbar open={message != null} autoHideDuration={autoHideDuration} onClose={onClose}>
      <Alert severity={shown.severity} onClose={onClose} sx={[toastAlertSx, toastFlowingBorderSx]}>
        {shown.message}
      </Alert>
    </AppSnackbar>
  );
}
